import reducer from '@redux/reducers'
import { configureStore } from '@reduxjs/toolkit'

export const initializeStore = (preloadedState = {}) =>
  configureStore({
    reducer: reducer,
    preloadedState,
    devTools: true,
  })
